import ResizableContainer from "../core/ResizableContainer";
import ResizableScene from "../core/ResizableScene";
import ScaleManager from "../core/ScaleManager";

export default class LoadingConatiner extends ResizableContainer {
	private _resize: () => void;

	private loadingBarFill: Phaser.GameObjects.Image;
	private maskImg: Phaser.GameObjects.Image;

	// private footer: Phaser.GameObjects.Container;

	private _percent: number;

	constructor(scene: ResizableScene) {
		super(scene, 0, 0);

		const bg = scene.add.image(0, 0, "splashBG");
		this.add(bg);

		const logo = scene.add.image(0, 0, "loadingLogo");
		this.add(logo);

		const bushes = scene.add.image(0, 0, "splashBushes");
		bushes.setOrigin(0.5, 1);
		this.add(bushes);

		const loadingBarBG = scene.add.image(0, 0, "loadingBarBG");
		this.add(loadingBarBG);

		const loadingBarFill = (this.loadingBarFill = scene.add.image(0, 0, "loadingBarFill"));
		this.add(loadingBarFill);

		const maskImg = (this.maskImg = this.scene.add.image(0, 0, "loadingBarFill"));
		this.add(maskImg);
		maskImg.visible = false;
		const mask = maskImg.createBitmapMask();
		loadingBarFill.mask = mask;

		this._percent = 0;

		this._resize = (): void => {
			const bounds = scene.viewport;
			ScaleManager.ScaleBackgroundFromZone(bg, bounds);
			ScaleManager.MatchWidth(bushes, bounds.width);
			scene.alignIn.Center(bg, bounds);
			scene.alignIn.Center(logo, bounds, 0, -100);
			scene.alignIn.Center(loadingBarBG, bounds, 0, 120);
			scene.alignIn.Center(loadingBarFill, loadingBarBG);
			scene.alignIn.Center(maskImg, loadingBarFill);
			scene.alignIn.BottomCenter(bushes, bounds);
		};
		this.resize();
		this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
	}

	update(): void {
		this.maskImg.setPosition(this.loadingBarFill.x - (1 - this._percent) * this.loadingBarFill.width, this.loadingBarFill.y);
	}

	setLoadPercent(percent: number): void {
		percent = !isNaN(percent) ? percent : 0;
		this._percent = Phaser.Math.Clamp(percent, 0, 1);
	}

	resize(): void {
		super.resize();
		if (this._resize) this._resize();
	}

	shutdown(): void {
		if (this.scene) this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this);
		super.shutdown();
	}
}
